import { createFileRoute } from '@tanstack/react-router'
import { useRouteDigitalProductId } from '@/shared/hooks/useRouteDigitalProductId'

import { DigitalProductLiveStreams } from '@/features/live-streams'

export const Route = createFileRoute('/_event/transmissoes/')({
  component: DigitalProductLiveStreamsPage
})

function DigitalProductLiveStreamsPage() {
  const digitalProductId = useRouteDigitalProductId()

  return <DigitalProductLiveStreams digitalProductId={digitalProductId} />
}
